const getActiveTool = (rootState) => rootState.ui.customTools.activeTool;

export default getActiveTool;
